export default {
	items: [
        {
            name: 'Active Files',
            url: '/dashboard',
            security: true,
            icon: 'fas fa-file-audio'
        },
        {
            name: 'Favorites',
            url: '/favorites',
            security: false,
            icon: 'far fa-star'
        },
        {
          name: 'Archived Files',
          url: '/archives',
          security: true,
          icon: 'fas fa-archive'
        },
        {
          name: 'Historical Files',
          url: '/historical',
          security: true,
          icon: 'fas fa-landmark'
        },
		{
			name: 'Admin Functions',
			icon: 'fa fa-puzzle-piece',
			children: [
				{
					name: 'Manage Files',
					url: '/managefiles',
					security: true,
					icon: 'fas fa-file-audio'
				},
				{
					name: 'File Uploads',
					url: '/fileuploads',
					security: true,
					icon: 'fas fa-cloud-upload-alt'
				},
				{
					name: 'File Specifications',
					url: '/filespecifications',
					security: true,
					icon: 'fas fa-tags'
				},
				{
					name: 'Clients',
					url: '/organizations',
					security: true,
					icon: 'fas fa-building',
				},
				{
					name: 'Users',
					url: '/users',
					security: true,
					icon: 'fas fa-user',
				},
				{
					name: 'Super User Password',
					url: '/superuserpassword',
					security: true,
					icon: 'fas fa-lock-open'
				},
				{
					name: 'Settings',
					url: '/settings',
					security: true,
					icon: 'fas fa-wrench'
				},
				{
					name: 'Help Text',
					url: '/helptext',
					security: true,
					icon: 'fas fa-question-circle'
				},
				{
					name: 'System Text',
					url: '/systemtext',
					security: true,
					icon: 'fas fa-file-alt'
				},
				{
					name: 'Login Roles',
					url: '/loginroles',
					security: true,
					icon: 'fas fa-lock'
				},
			]
		},
		{
			divider: true
		},


	]
}
